import { render, staticRenderFns } from "./ProductOldCard.vue?vue&type=template&id=a6eff68c&scoped=true"
import script from "./ProductOldCard.vue?vue&type=script&lang=js"
export * from "./ProductOldCard.vue?vue&type=script&lang=js"
import style0 from "./ProductOldCard.vue?vue&type=style&index=0&id=a6eff68c&prod&lang=scss&scoped=true"
import style1 from "./ProductOldCard.vue?vue&type=style&index=1&id=a6eff68c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6eff68c",
  null
  
)

export default component.exports